// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");

function makeSingleFamilyAttributesInput(beds, baths, halfBaths, lotSize, livingArea) {
  if (beds !== undefined && baths !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        baths: baths,
        beds: beds,
        halfBaths: halfBaths,
        livingArea: livingArea,
        lotSize: lotSize
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: "error making singleFamilyAttributes"
    };
  }
}

function makeCondoAttributesInput(beds, baths, halfBaths, lotSize, livingArea, parkingSpaces, parkingDetails) {
  if (beds !== undefined && baths !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        baths: baths,
        beds: beds,
        halfBaths: halfBaths,
        livingArea: livingArea,
        lotSize: lotSize,
        parkingDetails: parkingDetails,
        parkingSpaces: parkingSpaces
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: "error making condoAttributesInput"
    };
  }
}

function make(propertyType, beds, baths, halfBaths, lotSize, livingArea, parkingSpaces, parkingDetails) {
  if (propertyType === "CONDO") {
    return Stdlib_Result.map(makeCondoAttributesInput(beds, baths, halfBaths, lotSize, livingArea, parkingSpaces, parkingDetails), condo => ({
      condo: condo
    }));
  } else {
    return Stdlib_Result.map(makeSingleFamilyAttributesInput(beds, baths, halfBaths, lotSize, livingArea), singleFamily => ({
      singleFamily: singleFamily
    }));
  }
}

let Schema;

exports.Schema = Schema;
exports.makeSingleFamilyAttributesInput = makeSingleFamilyAttributesInput;
exports.makeCondoAttributesInput = makeCondoAttributesInput;
exports.make = make;
/* No side effect */
